export {
  VaGoalTableComponent,
  FooterConfig,
  LocationConfig,
  DataSourceConfig,
  GaGoalData,
  GoalTableConfig,
  GoalTableColumnConfig,
  GoalTableHeaderConfig,
} from './goal-table.component';
export { VaGoalTableModule } from './goal-table.module';
